import {
    Component,
    ElementRef,
    ChangeDetectionStrategy,
    ViewEncapsulation
} from '@angular/core';

/**
 * Button Group Component
 * See storybook for examples.
 *
 * @example
 * <pay-button-group>
 *      <button payButton>
 *          <span>Button Example</span>
 *      </button>
 * </pay-button-group>
 *
 * @export
 * @class ButtonGroupComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'pay-button-group',
    templateUrl: './button-group.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-btn-group'
    }
})

export class ButtonGroupComponent {
    private nativeElement: HTMLElement;

    constructor(private element: ElementRef) {
        this.nativeElement = element.nativeElement;
    }
}
